import api from "@/api/api";
import { iniciarRequisicao, logout } from "@/helpers";
import { STATUS_HTTP } from "@/api/statusHTTP";

export const buscarFiliaisParametrizacao = async () => {
  const url = `/parametrizacao/filial`;
  const {data, status} = await api.get(url, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.filiais;
}

export const salvarFiliaisParametrizacao = async (parametros) => {
  const url = `/parametrizacao/filial/salvar`;
  const {data, status} = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.filiais;
}

export const editarFiliaisParametrizacao = async (parametros) => {
  const url = `/parametrizacao/filial/editar/${parametros.idfilial}`;
  const {data, status} = await api.put(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.filiais;
}
